<template>
  <div
    class="contacts-card"
    :class="{
      'contacts-card_active': isActive,
      'contacts-card_with-hover': withHover,
    }"
  >
    <div class="contacts-card__content">
      <div class="contacts-card__label">
        {{ label }}
      </div>
      <slot name="content">
        <span v-if="text">{{ text }}</span>
      </slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FaqAndSupportContactsCard',
  props: {
    label: {
      type: String,
      default: '',
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    withHover: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped lang="scss">
.contacts-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 196px;
  padding: 16px;
  border-radius: 24px;
  font-family: $font-mts-compact;
  font-size: 24px;
  line-height: 32px;
  font-weight: 400;
  color: $color-dark-2;
  background: $color-white;
  transition: background-color 0.3s;

  @include screen-down('md') {
    min-height: 180px;
  }

  @include screen-down(375px) {
    font-size: 20px;
    line-height: 28px;
  }

  &_active {
    background-color: rgba(188, 195, 208, 0.45);
  }

  &_with-hover {
    cursor: pointer;

    &:hover:not(.contacts-card_active) {
      @media screen and (hover: hover) {
        background-color: rgba(188, 195, 208, 0.25);
      }
    }
  }

  &__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &__label {
    margin-bottom: 8px;
    font-size: 20px;
    line-height: 28px;
    color: $color-gray-1;
  }
}
</style>
